import * as t from './actionTypes';
import {
  fetchEnabledAccountsResponse,
  fetchEnabledAccountsRequest,
  fetchEnabledAccountsError,
} from './actions';
import type { EnabledAccountsReducerState } from './types';

type EnabledAccountsReducerAction =
  | ReturnType<typeof fetchEnabledAccountsResponse>
  | ReturnType<typeof fetchEnabledAccountsRequest>
  | ReturnType<typeof fetchEnabledAccountsError>;

export const enabledAccountsReducerInitialState: EnabledAccountsReducerState['baus']['enabledAccounts'] =
  {
    enabledAccounts: [],
    isLoading: false,
  };

export const enabledAccountsReducer = (
  state = enabledAccountsReducerInitialState,
  action: EnabledAccountsReducerAction,
) => {
  switch (action.type) {
    case t.FETCH_ENABLED_ACCOUNTS_RESPONSE: {
      return {
        ...state,
        enabledAccounts: action.response,
        isLoading: false,
      };
    }
    case t.FETCH_ENABLED_ACCOUNTS_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.FETCH_ENABLED_ACCOUNTS_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default: {
      return state;
    }
  }
};
